// extracted by mini-css-extract-plugin
export default {"imageWrapper":"vR-z","hovered":"wR-z","hoverImage":"xR-z","mainImage":"yR-z","imageNoBackground":"zR-z","fullSizeImage":"AR-z"};